import { round as _round } from "lodash";

("use strict");

var abs = Math.abs;
var round = Math.round;

function almostEq(a, b) {
  return abs(a - b) <= 9.5367432e-7;
}

// Greatest Common Divisor
function GCD(a, b) {
  if (almostEq(b, 0)) return a;
  return GCD(b, a % b);
}

function findPrecision(n) {
  var e = 1;

  while (!almostEq(round(n * e) / e, n)) {
    e *= 10;
  }

  return e;
}

function num2fraction(num) {
  if (num === 0 || num === "0") return "0";

  if (typeof num === "string") {
    num = parseFloat(num);
  }

  var precision = findPrecision(num);
  var number = num * precision;
  var gcd = abs(GCD(number, precision));

  var numerator = number / gcd;

  var denominator = precision / gcd;

  return {
    numerator: round(numerator),
    denominator: round(denominator),
  };
}

const recalculateName = ({ full, piece, divider, multiplier, counter, unit, ingredient }) => {
  piece = piece || 0;
  divider = divider || 1;

  const decimal = (full * divider + piece) / divider;
  const result = (decimal / multiplier) * counter;
  const fraction = num2fraction(result);

  let fullTxt = "";
  let piecesTxt = "";
  const { numerator: n, denominator: d } = fraction;
  const { floor } = Math;

  if (d > 8) {
    fullTxt = `${_round(n / d, 2)} `;
  } else if (d > 1) {
    let f = floor(n / d);
    fullTxt = f > 0 ? `${f} ` : "";
    piecesTxt = `${n % d}/${d} `;
  } else if (n > 0) {
    fullTxt = `${n} `;
  }

  return `${fullTxt}${piecesTxt}${unit ?? ""} ${ingredient ?? ""}`;
};

const recalculateNames = ({ ingredients, yields: { original_value } }, counter) => {
  for (let ingredient of ingredients) {
    for (let item of ingredient.items) {
      const { ingr_name: ingredient, ingr_unit_name: unit, original } = item;
      item.name = recalculateName({
        full: +original.full,
        piece: +original.piece,
        divider: +original.divider,
        multiplier: +original_value,
        counter,
        unit,
        ingredient,
      });
    }
  }
};

export default recalculateNames;
